import React, { useState } from "react";
import { Button } from "antd";
import Questionbanks from "../../Questionbanks/Questionbanks";
import DistrictQuestionbanksItemDetail from "../../Questionbanks/DistrictQuestionbanksItemDetail";
import { useRouteMatch, Route } from "react-router-dom";
import { currentUserSelector } from "../../Auth/Login/selector";
import { useSelector } from "react-redux";
import LibraryQuestionbanksLayout from "./LibraryQuestionbanksLayout";
import LibraryQuestionBankList from "./LibraryQuestionBankList";


const LibraryQuestionBanks = (props) => {
  console.log("library page district view props", props)
  const { path } = useRouteMatch();
  const currentUser = useSelector(currentUserSelector())
  
  return (
    <>
      <Route
        path={`${path}`}
        render={(routeProps) => (
          <Questionbanks
            // resourceId={currentUser.org_id}
            embedded={false}
            isRoute={false}
            {...routeProps}
            params={{by_created_by_org_id: currentUser.org_id}}
            config={{
              routes: { fetch: true },
              itemDetail: { widget: DistrictQuestionbanksItemDetail },
              list: { widget: LibraryQuestionBankList, layout: LibraryQuestionbanksLayout },
            }}
          />
        )}
      />

    </>
  );
};

export default LibraryQuestionBanks;